"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCaptureRouteNotFound = exports.RouteNotFound = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Loader_1 = require("@reactionable/core/lib/ui/loader/Loader");
const react_router_dom_1 = require("react-router-dom");
const RouteNotFound = () => (jsx_runtime_1.jsx(react_router_dom_1.Redirect, { to: { state: { notFoundError: true } } }, void 0));
exports.RouteNotFound = RouteNotFound;
function CaptureRouteNotFound({ notFoundComponent, children, }) {
    const location = react_router_dom_1.useLocation();
    const shouldDisplayNotFoundComponent = location && location.state && location.state.notFoundError;
    if (shouldDisplayNotFoundComponent) {
        const NotFoundComponent = Loader_1.lazyLoad(notFoundComponent);
        return jsx_runtime_1.jsx(NotFoundComponent, {}, void 0);
    }
    if (children) {
        return jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: children }, void 0);
    }
    return null;
}
const useCaptureRouteNotFound = (notFoundComponent) => react_router_dom_1.withRouter(({ children }) => (jsx_runtime_1.jsx(CaptureRouteNotFound, Object.assign({ notFoundComponent: notFoundComponent }, { children: children }), void 0)));
exports.useCaptureRouteNotFound = useCaptureRouteNotFound;
//# sourceMappingURL=NotFound.js.map